import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';



const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const CdcsFilter = props => (
    <Filter {...props}>
        <DateInput source="donation_date" alwaysOn lable='Donation Date'  locales="en-us"/>
    </Filter>
);

export const CdcsList = props => (
    <List 
        {...props}
        filters={<CdcsFilter />}
        perPage={20}
        sort={{ field: 'donation_date', order: 'ASC' }}
        bulkActionButtons ={false}
        title="CDCS Donations"
        >
        <Datagrid >
            <DateField source="donation_date" label="Donation Date" locales="en-us"/>    
            <TextField source="site_code" label="Site code" />
            <TextField source="first_name" label="First name" />
            <TextField source="last_name" label="Last name"/>
            <TextField source="middle_init" label="Middle Initial"  />
            <DateField source="birth_date" label="Birth Date" locales="en-us"/>    
            <TextField source="gender" label="Gender"/>
            <TextField source="donor_id" label="Donor ID"/>
            <TextField source="donor_id_type" label="Donor Id Type"/>
            <TextField source="donation_volume" label="Donation Volume (ml)"/>
        </Datagrid>
    </List>
);


export default CdcsList